import { ChangeDetectorRef, Component, Inject, Input, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
  MatLegacyDialog
} from "@angular/material/legacy-dialog";
import { Router } from '@angular/router';
import { CtButtonConfiguration, CtGenericDialogComponent, CtGenericDialogConfiguration, MAT_RAISED_PRIMARY } from '@ctsolution/ct-framework';
import { CtWebapiGenericResponse, CtWebapiService, DataRequest, MethodEnum } from '@ctsolution/ct-webapi';
import { lastValueFrom } from 'rxjs';
@Component({
  selector: 'app-work-order-clone',
  templateUrl: './work-order-clone.component.html',
  styleUrls: ['./work-order-clone.component.scss']
})
export class WorkOrderCloneComponent implements OnInit {

  @Input() pid: number | null = null;
  @Input() isQuotation : boolean = false;

  cloneConfiguration: CtButtonConfiguration = CtButtonConfiguration.create()
    .setLabel("Clone")
    .setIcon("content_copy")
    .setMatherialOptions(MAT_RAISED_PRIMARY)
    .setAction(() => this.open())

  constructor(
    public dialogRef: MatDialogRef<WorkOrderCloneComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private dialog: MatLegacyDialog,
    private cdr: ChangeDetectorRef,
    private _webapi: CtWebapiService
  ) { }

  ngOnInit() {
  }

  async open() {

    const dialogConfig = this.createDialogConfig();
    const res = await lastValueFrom(this.dialog.open(CtGenericDialogComponent, { data: { configuration: dialogConfig } }).afterClosed());

    if (!res || !this.pid) return;

    try {
      const result = await this.cloneWorkOrder();
      if (result) {
        this.navigateToWorkOrderEdit(result);
      }
    } catch (error) {
      console.error("Errore durante la clonazione del Work Order:", error);
    }
  }

  /** Crea la configurazione per il dialog */
  private createDialogConfig(): CtGenericDialogConfiguration {
    return CtGenericDialogConfiguration.create()
      .setTitle( this.isQuotation? "quotationClone" : "workOrderClone")
      .setContent(this.isQuotation? "quotationCloneContent":"workOrderCloneContent")
      .setSubmitLabel("Clone")
      .setCancelLabel("Annulla");
  }

  /** Clona il Work Order e restituisce il risultato */
  private async cloneWorkOrder(): Promise<any> {
    const request = DataRequest.create()
      .setController(["workorder"])
      .setAction("Clone")
      .setBody({ workOrderOid: this.pid })
      .setMethod(MethodEnum.POST);

    const response: CtWebapiGenericResponse<any> = await lastValueFrom(this._webapi.request(request));
    return response?.Result;
  }

  /** Naviga alla pagina di modifica del Work Order clonato */
  private navigateToWorkOrderEdit(workOrderOid: any) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      if(this.isQuotation)
        this.router.navigate(['/','work-order','quotations','edit',workOrderOid])
      else
        this.router.navigate(['/','work-order','edit', workOrderOid]);
    });  }

}
